import React from 'react';
import classnames from 'classnames';
// import InlineWatermark from '@intelligence/components/InlineWatermark';
import ReportWallpaperHeader from './Header';
import ReportWallpaperFooter from './Footer';
// import { captureExpendClassName } from '@intelligence/utils/captureUtils';
import { DPS_REPORT_STYLE_CFG } from '../../constants';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IReportWallpaperProps extends IBaseProps {
  dateTitle?: string;
}

const ReportWallpaper: React.ForwardRefRenderFunction<HTMLDivElement, IReportWallpaperProps> = (props, ref) => {
  const { style, className, dateTitle, children } = props;

  return (
    <div
      ref={ref}
      style={{
        ...style,
        paddingTop: `${(DPS_REPORT_STYLE_CFG.FIRST_CARD_TOP / DPS_REPORT_STYLE_CFG.POSTER_WIDTH) * 100}%`,
      }}
      className={classnames('dbg-dps-report-wallpaper', className)}
    >
      <ReportWallpaperHeader dateTitle={dateTitle} />
      <div className="dbg-dps-report-wallpaper__content">{children}</div>
      <ReportWallpaperFooter />
      {/* <InlineWatermark className={classnames('dbg-dps-report__watermark', captureExpendClassName)} /> */}
    </div>
  );
};

export default React.forwardRef(ReportWallpaper);
